export default {
  'content-box': {
    label: 'Content box',
    type: 'toggle',
    category: 'Content box',
    hint:
      'Wrap the content in a box. This helps make content more visible when on a background image.'
  },
  'content-box-wrap': {
    label: 'Content box wrap',
    type: 'radio',
    options: [
      { value: 'content', text: 'All content' },
      { value: 'item', text: 'Items' }
    ],
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box',
    hint:
      '"All content" will wrap the entire content area while "Items" will wrap items individually.'
  },
  'content-box-color': {
    label: 'Content box color',
    type: 'background-color',
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box'
  },
  'content-box-padding': {
    label: 'Content box padding',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box'
  },
  'content-box-opacity': {
    label: 'Content box opacity',
    type: 'slider',
    min: 0,
    max: 1,
    step: 0.01,
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box',
    hint:
      'Set the transparency of the content box. 0 is fully transparent and 1 is fully visible.'
  },
  'content-box-elevation': {
    label: 'Content box elevation',
    type: 'slider',
    min: 0,
    max: 24,
    step: 1,
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box',
    hint:
      'Add shadows to the content box to make it appear elevated. Higher value adds a more visible shadow.'
  },
  'content-box-border': {
    label: 'Content box border',
    type: 'slider',
    min: 0,
    max: 10,
    step: 1,
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box',
    hint: 'Add border to the content box. Higher value adds thinker borders.'
  },
  'content-box-border-color': {
    label: 'Content box border',
    type: 'text-color',
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box'
  },
  'content-box-rounded': {
    label: 'Content box rounded',
    type: 'toggle',
    showOn: {
      field: 'content-box',
      operator: '==',
      value: '1'
    },
    category: 'Content box',
    hint:
      'Add rounded corners to the content box. The radius of the corners can be controlled via the "Template settings" panel.'
  }
}
